export const SearchClientInputComponent = {
  templateUrl:
    './app/ajs/_shared/components/search-client-input/search-client-input.component.html',
  bindings: {
    client: '<',
    clientSelected: '&',
    clientValidated: '&',
    clientCleared: '&',
    placeholder: '<',
    isRequired: '<',
    isDisabled: '<',
  },
  controller: SearchClientInputController,
  controllerAs: 'vm',
};

SearchClientInputController.$inject = ['ClientService'];

function SearchClientInputController(ClientService) {
  const vm = this;

  // vm.$onInit = function() {
  //     setTimeout(() => { // hack
  //         document.querySelector('input[name="client_id"]').focus();
  //     }, 500);
  // };

  // public methods
  // -----------------------
  vm.searchClient = function (search) {
    if (search.length < 2) return;

    const params = {
      get: 'active',
      by_client: search,
      skip_check_role: true,
    };

    return ClientService.getClients(params).then(function (data) {
      if (data.items.length === 0) {
        vm.clientCleared({ $clearObj: false });
      }

      return data.items;
    });
  };

  vm.selectClient = function (client) {
    // console.log('selectClient');
    // console.log(client);
    vm.clientSelected({ $event: client });
  };

  vm.validateClient = function () {
    // console.log('validateClient');
    // console.log(vm.client);
    vm.clientValidated({ $event: vm.client });
  };

  vm.clearClient = function () {
    // console.log('clearClient');
    // vm.client = null;

    vm.clientCleared({ $clearObj: true });
  };
}
